const SvgClose3 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24">
    <path fill="#373737" fillRule="evenodd" d="M12.853 12 20 19.111l-.812.808-7.147-7.11L4.812 20 4 19.192 11.228 12 4 4.808 4.812 4l7.229 7.192 7.147-7.111.812.808z" clipRule="evenodd" />
  </svg>;
export default SvgClose3;